import axios from 'axios';
import { APP_DOMAIN, FETCH_PRODUCT_URL } from 'appenv';

const getEventProductCategories = async () => {
  try {
    const categoriesResponse = await axios.get(`${FETCH_PRODUCT_URL}/categories?domain=${APP_DOMAIN}`);
    return categoriesResponse.data;
  } catch (e) {
    return null;
  }
};

export default getEventProductCategories;
